import { ROLES } from "../const/roles"
import type { RoleStrategy } from "../hooks"

type QueryOptions = {
  gcTime?: number
  staleTime?: number
}

const timeout = 60 * 60 * 1000 // 1h
const options: QueryOptions = { gcTime: timeout, staleTime: timeout }

export const datarefQueryRoleconf = (): RoleStrategy<QueryOptions> => ({
  [ROLES.ADMIN]: {
    staleTime: 0,
    gcTime: 30000,
  },
  [ROLES.ADHERENT_ADVISOR]: options,
  [ROLES.UPP_PRESIDENT]: options,
  [ROLES.UPP_REPRESENTATIVE]: options,
  [ROLES.UPP_TREASURER]: options,
  [ROLES.ADHERENT_HOLDER]: options,
  [ROLES.ADHERENT_TEAM]: options,
  [ROLES.ADHERENT_EMPLOYEE]: options,
  [ROLES.EXTERN_CONTACT_LABORATORY]: options,
})
